import React, { useEffect, useState } from 'react';
import { ArrowRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { CleanerIllustration, LivingRoomIllustration, EcoIllustration } from './illustrations/Illustrations';
import { useBooking } from '../context/BookingContext';
import { useT } from '../i18n/LanguageContext';

const illustrations = [CleanerIllustration, LivingRoomIllustration, EcoIllustration];

export default function Hero() {
  const [index, setIndex] = useState(0);
  const { openModal } = useBooking();
  const { t } = useT();

  const slides = [
    { tag: t('hero.s1.tag'), title: t('hero.s1.title'), highlight: t('hero.s1.highlight'), sub: t('hero.s1.sub'), cta: t('hero.s1.cta') },
    { tag: t('hero.s2.tag'), title: t('hero.s2.title'), highlight: t('hero.s2.highlight'), sub: t('hero.s2.sub'), cta: t('hero.s2.cta') },
    { tag: t('hero.s3.tag'), title: t('hero.s3.title'), highlight: t('hero.s3.highlight'), sub: t('hero.s3.sub'), cta: t('hero.s3.cta') },
  ];

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % slides.length), 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const slide = slides[index];
  const Illustration = illustrations[index] || CleanerIllustration;

  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);
  const next = () => setIndex((i) => (i + 1) % slides.length);

  return (
    <section id="home" className="relative w-full uc-mint-bg overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 md:py-24 grid lg:grid-cols-2 gap-10 items-center">
        <div key={`t-${index}`} className="uc-fade-up">
          <p className="uc-kicker mb-4">{slide.tag}</p>
          <h1 className="font-serif text-5xl md:text-6xl font-bold leading-[1.1] mb-5 text-[#1a2851]">
            {slide.title}
            <br />
            <span className="text-[#4dbfae]">{slide.highlight}</span>
          </h1>
          <p className="text-lg text-[#5b6469] max-w-xl mb-8 leading-relaxed">{slide.sub}</p>
          <div className="flex flex-wrap gap-4">
            <button onClick={openModal} className="uc-btn">
              {slide.cta}
              <ArrowRight size={18} />
            </button>
            <a href="#services" className="uc-btn-outline">{t('hero.ourServices')}</a>
          </div>

          <div className="flex gap-3 mt-10">
            {slides.map((_, i) => (
              <button
                key={i}
                aria-label={`Slide ${i + 1}`}
                onClick={() => setIndex(i)}
                className={`h-2 rounded-full transition-all ${
                  i === index ? 'w-10 bg-[#4dbfae]' : 'w-2 bg-[#c4e6df]'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="relative">
          <div key={`i-${index}`} className="uc-fade-up relative">
            <Illustration className="w-full h-auto max-h-[520px] drop-shadow-xl" />
          </div>
        </div>
      </div>

      <button onClick={prev} aria-label="Previous" className="hidden md:flex absolute left-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white hover:bg-[#4dbfae] hover:text-white text-[#1a2851] items-center justify-center shadow-md transition-colors">
        <ChevronLeft size={22} />
      </button>
      <button onClick={next} aria-label="Next" className="hidden md:flex absolute right-4 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white hover:bg-[#4dbfae] hover:text-white text-[#1a2851] items-center justify-center shadow-md transition-colors">
        <ChevronRight size={22} />
      </button>
    </section>
  );
}
